// libraries
import { z } from 'zod';

export function createEditMatrikelBuildingFormSchema() {
  return z.object({
    averageBuildingYear: z.number().nullable(),
    sumBuildingArea: z.number().nullable(),
    extractedBuildingUse: z.string(),
    extractedHeatInstallation: z.string(),
    verificationFlag: z.boolean(),
  });
}

export type EditMatrikelBuildingFormValues = z.infer<
  ReturnType<typeof createEditMatrikelBuildingFormSchema>
>;
